var _YfmEditor_view, _YfmEditor_serializer, _YfmEditor_parser, _YfmEditor_actions, _YfmEditor_contentHandler;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { EditorState } from 'prosemirror-state';
import { EditorView } from 'prosemirror-view';
import { WysiwygContentHandler } from './ContentHandler';
import { ExtensionsManager } from './ExtensionsManager';
import { bindActions } from './utils/actions';
import { logTransactionMetrics } from './utils/metrics';
export class YfmEditor {
    constructor({ domElem, initialContent = '', extensions = () => { }, attrs: attrsOpts, allowHTML, linkify, linkifyTlds, onChange, onDocChange, }) {
        _YfmEditor_view.set(this, void 0);
        _YfmEditor_serializer.set(this, void 0);
        _YfmEditor_parser.set(this, void 0);
        _YfmEditor_actions.set(this, void 0);
        _YfmEditor_contentHandler.set(this, void 0);
        const { schema, parser, serializer, nodeViews, markViews, plugins, rawActions, actions } = ExtensionsManager.process(extensions, {
            // "breaks" option only affects the renderer, but not the parser
            mdOpts: { html: allowHTML, linkify, breaks: true },
            attrsOpts: Object.assign(Object.assign({}, attrsOpts), { allowedAttributes: ['id'] }),
            linkifyTlds,
        });
        const state = EditorState.create({
            schema,
            doc: parser.parse(initialContent),
            plugins,
        });
        const thisOnChange = () => this.tryOnChange(onChange);
        const thisOnDocChange = () => this.tryOnChange(onDocChange);
        __classPrivateFieldSet(this, _YfmEditor_view, new EditorView(domElem !== null && domElem !== void 0 ? domElem : null, {
            state,
            nodeViews,
            markViews,
            dispatchTransaction(tr) {
                const newState = this.state.apply(tr);
                // @ts-expect-error
                this.updateState(newState);
                thisOnChange();
                if (tr.docChanged) {
                    thisOnDocChange();
                }
                logTransactionMetrics(tr);
            },
        }), "f");
        __classPrivateFieldSet(this, _YfmEditor_actions, actions.setActions(bindActions(rawActions)(__classPrivateFieldGet(this, _YfmEditor_view, "f"))), "f");
        __classPrivateFieldSet(this, _YfmEditor_serializer, serializer, "f");
        __classPrivateFieldSet(this, _YfmEditor_parser, parser, "f");
        __classPrivateFieldSet(this, _YfmEditor_contentHandler, new WysiwygContentHandler(__classPrivateFieldGet(this, _YfmEditor_view, "f"), parser), "f");
    }
    get dom() {
        return __classPrivateFieldGet(this, _YfmEditor_view, "f").dom;
    }
    get serializer() {
        return __classPrivateFieldGet(this, _YfmEditor_serializer, "f");
    }
    get parser() {
        return __classPrivateFieldGet(this, _YfmEditor_parser, "f");
    }
    get actions() {
        return __classPrivateFieldGet(this, _YfmEditor_actions, "f").actions;
    }
    /** @internal used for prosemirror-dev-tools in demo */
    get view() {
        return __classPrivateFieldGet(this, _YfmEditor_view, "f");
    }
    action(actionName) {
        return __classPrivateFieldGet(this, _YfmEditor_actions, "f").action(actionName);
    }
    focus() {
        return __classPrivateFieldGet(this, _YfmEditor_view, "f").focus();
    }
    hasFocus() {
        return __classPrivateFieldGet(this, _YfmEditor_view, "f").hasFocus();
    }
    getValue() {
        return __classPrivateFieldGet(this, _YfmEditor_serializer, "f").serialize(__classPrivateFieldGet(this, _YfmEditor_view, "f").state.doc);
    }
    isEmpty() {
        var _a;
        const { doc } = __classPrivateFieldGet(this, _YfmEditor_view, "f").state;
        return (doc.childCount === 1 &&
            ((_a = doc.firstChild) === null || _a === void 0 ? void 0 : _a.type.name) === 'paragraph' &&
            doc.firstChild.childCount === 0);
    }
    clear() {
        return __classPrivateFieldGet(this, _YfmEditor_contentHandler, "f").clear();
    }
    replace(newMarkup) {
        return __classPrivateFieldGet(this, _YfmEditor_contentHandler, "f").replace(newMarkup);
    }
    prepend(markup) {
        return __classPrivateFieldGet(this, _YfmEditor_contentHandler, "f").prepend(markup);
    }
    append(markup) {
        return __classPrivateFieldGet(this, _YfmEditor_contentHandler, "f").append(markup);
    }
    moveCursor(position) {
        return __classPrivateFieldGet(this, _YfmEditor_contentHandler, "f").moveCursor(position);
    }
    destroy() {
        __classPrivateFieldGet(this, _YfmEditor_view, "f").destroy();
    }
    tryOnChange(cb) {
        if (cb) {
            try {
                cb(this);
            }
            catch (err) {
                console.error(err);
            }
        }
    }
}
_YfmEditor_view = new WeakMap(), _YfmEditor_serializer = new WeakMap(), _YfmEditor_parser = new WeakMap(), _YfmEditor_actions = new WeakMap(), _YfmEditor_contentHandler = new WeakMap();
